import React from "react";
import styled, { css } from "styled-components";
import { Tooltip, Checkbox } from "@material-ui/core";

const toolTipIcon = require("../../../../assets/images/white_tooltip.svg").default;
const sortIcon = require("../../../../assets/images/sortIcon.svg").default;

const CustomHeader = ({ MTRef, ...props }) => {
  function handleSort(column) {
    if (column.hasOwnProperty("sorting") && !column.sorting) {
      return false;
    }
    const oldQuery = MTRef?.current?.state?.query;
    if (oldQuery) {
      const orderBy = { field: column.field };
      let orderDirection = "asc";
      if (oldQuery.orderBy?.field && oldQuery.orderBy?.field === column.field) {
        orderDirection = oldQuery.orderDirection === "asc" ? "desc" : "asc";
      }
      const newQuery = { ...oldQuery, orderBy, orderDirection };
      MTRef.current.onQueryChange(newQuery);
    }
  }

  const isSorted = (column) => {
    const oldQuery = MTRef?.current?.state?.query;
    return oldQuery?.orderBy?.field === column.field;
  };

  const getSortDirection = (column) => {
    const oldQuery = MTRef?.current?.state?.query;
    return oldQuery?.orderDirection || "asc";
  };

  const isSortable = (column) => {
    if (column.hasOwnProperty("sorting")) {
      return column.sorting;
    }
    return true;
  };

  return (
    <StyledTableHead className="MuiTableHead-root">
      <StyledTableRow className="MuiTableRow-root MuiTableRow-head">
        {props.hasSelection ? (
          <SelectionTH>
            <CheckboxWrapper>
              <Checkbox
                style={{ backgroundColor: "#293461" }}
                onChange={(e) => props.onAllSelected(e.target.checked)}
                checked={props.dataCount === props.selectedCount}
                icon={
                  <CustomCheckboxIcon
                    alt="unchecked"
                    src={require("../../../../assets/images/checkboxWhite.svg").default}
                  />
                }
                checkedIcon={
                  <CustomCheckboxIcon
                    alt="checked"
                    src={require("../../../../assets/images/checkBoxSelectedWhite.svg").default}
                  />
                }
              />
            </CheckboxWrapper>
          </SelectionTH>
        ) : null}

        {props.columns.map((column) => (
          <HeaderCell
            key={`${column.field}-${column.title}`}
            style={column?.headerStyle}
            isHidden={column?.hidden}
            isSortable={isSortable(column)}
            onClick={() => handleSort(column)}
            className="MuiTableCell-root MuiTableCell-head MuiTableCell-alignLeft"
            // title={column.title}
          >
            <HeaderContent>
              <HeaderTitle>{column.title}</HeaderTitle>

              <HeaderIcons>
                {column.tooltip && (
                  <Tooltip title={column.tooltip} placement="top" arrow>
                    <TooltipIconWrapper>
                      <TooltipIcon src={toolTipIcon} alt="info" />
                    </TooltipIconWrapper>
                  </Tooltip>
                )}

                {isSortable(column) && (
                  <SortIconWrapper
                    isActive={isSorted(column)}
                    direction={getSortDirection(column)}
                  >
                    <SortIcon
                      src={sortIcon}
                      alt="sort"
                      direction={getSortDirection(column)}
                    />
                  </SortIconWrapper>
                )}
              </HeaderIcons>
            </HeaderContent>
          </HeaderCell>
        ))}

        {props.hasDetailPanel && <ExpandTH />}
      </StyledTableRow>
    </StyledTableHead>
  );
};

export default CustomHeader;

const StyledTableHead = styled.thead`
  background-color: #f8f9fa;
  border-bottom: 2px solid #e1e3ee;

  @media (max-width: 768px) {
    display: none;
  }
`;

const StyledTableRow = styled.tr`
  max-height: 44px;
  display: table-row;
  width: 100%;

  &:hover {
    background-color: #f0f2f5;
  }
`;

const SelectionTH = styled.th`
  min-width: 50px;
  width: 50px;
  padding: 12px 8px;
  text-align: center;
  vertical-align: middle;
  font-family: openSans-SemiBold, sans-serif;
  color: #7fa1c3;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-sizing: border-box;
  border-right: 1px solid #e1e3ee;

  @media (max-width: 1440px) {
    min-width: 45px;
    width: 45px;
    padding: 10px 6px;
  }

  @media (max-width: 1024px) {
    min-width: 40px;
    width: 40px;
    padding: 8px 4px;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  & .MuiCheckbox-root {
    padding: 4px;
  }

  & .MuiSvgIcon-root {
    width: 18px;
    height: 18px;
  }

  @media (max-width: 1440px) {
    & .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    }
  }
`;

const CustomCheckboxIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;

  @media (max-width: 1440px) {
    width: 16px;
    height: 16px;
  }
`;

const HeaderCell = styled.th`
  ${({ isHidden }) =>
    isHidden &&
    css`
      display: none;
    `}

  padding: 12px 8px;
  text-align: left;
  vertical-align: middle;
  font-family: openSans-SemiBold, sans-serif;
  color: #7fa1c3;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-sizing: border-box;
  border-right: 1px solid #e1e3ee;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
  user-select: none;

  ${({ isSortable }) =>
    isSortable &&
    css`
      cursor: pointer;

      &:hover {
        background-color: #f0f2f5;
        color: #667eea;
      }

      &:active {
        background-color: #e8e9ed;
      }
    `}

  ${({ isSortable }) =>
    !isSortable &&
    css`
      cursor: default;
    `}

  &:last-child {
    border-right: none;
  }

  @media (max-width: 1440px) {
    padding: 10px 6px;
    font-size: 11px;
  }

  @media (max-width: 1024px) {
    padding: 8px 4px;
    font-size: 10px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: space-between;
  min-height: 20px;

  @media (max-width: 1440px) {
    gap: 4px;
  }

  @media (max-width: 1024px) {
    gap: 2px;
  }
`;

const HeaderTitle = styled.span`
  font-family: openSans-SemiBold, sans-serif;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;

  @media (max-width: 1440px) {
    font-size: 11px;
  }

  @media (max-width: 1024px) {
    font-size: 10px;
  }
`;

const HeaderIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;

  @media (max-width: 1440px) {
    gap: 3px;
  }

  @media (max-width: 1024px) {
    gap: 2px;
  }
`;

const TooltipIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
    transform: scale(1.1);
  }

  @media (max-width: 1440px) {
    padding: 1px;
  }
`;

const TooltipIcon = styled.img`
  height: 16px;
  width: auto;
  object-fit: contain;
  display: block;

  @media (max-width: 1440px) {
    height: 14px;
  }

  @media (max-width: 1024px) {
    height: 12px;
  }
`;

const SortIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};

  &:hover {
    opacity: 1;
    transform: scale(1.2);
  }

  @media (max-width: 1440px) {
    padding: 1px;
  }
`;

const SortIcon = styled.img`
  width: 10px;
  height: 10px;
  object-fit: contain;
  display: block;
  transform: ${({ direction }) =>
    direction === "desc" ? "rotate(180deg)" : "rotate(0deg)"};
  transition: transform 0.2s ease;

  @media (max-width: 1440px) {
    width: 8px;
    height: 8px;
  }

  @media (max-width: 1024px) {
    width: 7px;
    height: 7px;
  }
`;

const ExpandTH = styled.th`
  min-width: 50px;
  width: 50px;
  padding: 12px 8px;
  text-align: center;
  vertical-align: middle;

  @media (max-width: 1440px) {
    min-width: 45px;
    width: 45px;
    padding: 10px 6px;
  }

  @media (max-width: 1024px) {
    min-width: 40px;
    width: 40px;
    padding: 8px 4px;
  }
`;
